import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useFormContext } from "react-hook-form-mui";
import DataContainer from "../../../../Utilities/DataContainer";
import RenderSelectField from "../../../../Utilities/Forms/RenderSelectField";
import RenderTextField from "../../../../Utilities/Forms/RenderTextField";
import monthDropdown from "../../../../Utilities/Constants/MonthDropdown";
import DropDownViewModel from "../../../../Utilities/ViewModels/DropDownViewModel";
import yesNoDropdown from "../../../../Utilities/Constants/YesNoDropdown";
import { APIContext } from "../../../../Contexts/APIContext";
import { useContext, useState } from "react";
import React from "react";
import ValidatedSelectElement from "../../../../Utilities/Forms/ValidatedSelectElement";
import ValidatedTextField from "../../../../Utilities/Forms/ValidatedTextField";
import CrabPie from "../../../../Utilities/CrabPie";
import DftConnectivityToolScores from "../../../DftConnectivityToolScores";
import SiteViewModel from "../../../ViewModels/SiteViewModel";
interface IProps {
    targetGroups: DropDownViewModel[] | null
    isReadOnly: boolean
    id: string
    site: SiteViewModel
}
export default function TravelPlanTargetsAndObjectives({ targetGroups, isReadOnly, id, site }: IProps) {

    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;
    const { get } = useContext(APIContext);
    const idSplit = id.split("-")
    const [prePlanChart, setPrePlanSvgUrl] = useState<PieSegment[]>([]);
    const [modalChart, setModalSvgUrl] = useState<PieSegment[]>([]);

    React.useEffect(() => {
        getTravelPlanChart();
    }, []);

    const getTravelPlanChart = () => {
        get('TravelPlan', `GetPrePlanModeSplitChart?id=${id}`, setPrePlanSvgUrl)
        get('TravelPlan', `GetModalSplitChart?id=${id}`, setModalSvgUrl)
    };

    const censusDataDropdown: DropDownViewModel[] = [{ id: "PS", label: "Previous Survey at Site" }, { id: "TA", label: "Trics Analysis" }, { id: "11", label: "2011 Census" }, { id: "21", label: "2021 Census" }];
   
   
    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {hasValues(["targetStaff", "targetVisitors", "targetCustomers", "targetStudents", "targetPatients", "targetAllUsers", "targetOtherUsers", "otherUserType"]) && (
                        <Grid container size={12}>
                            <Grid size={12}>
                                <DataContainer title="Travel Plan Target Group">
                                    <Grid size={12}>
                                        <Stack spacing={1}>
                                            {idSplit[1] === "03" &&
                                                <RenderSelectField label={"Residents"} name={"targetResidents"} readOnly={isReadOnly} options={targetGroups} labelSize={4} inputSize={8} />
                                            }
                                            {idSplit[1] !== "03" &&
                                                <RenderSelectField label={"Staff"} name={"targetStaff"} readOnly={isReadOnly} options={targetGroups} labelSize={4} inputSize={8} />
                                            }
                                            <RenderSelectField label={"Visitors"} name={"targetVisitors"} readOnly={isReadOnly} options={targetGroups} labelSize={4} inputSize={8} />
                                            {idSplit[1] !== "03" &&
                                                <>
                                                    <RenderSelectField label={"Customers"} name={"targetCustomers"} readOnly={isReadOnly} options={targetGroups} labelSize={4} inputSize={8} />
                                                    <RenderSelectField label={"Students"} name={"targetStudents"} readOnly={isReadOnly} options={targetGroups} labelSize={4} inputSize={8} />
                                                    <RenderSelectField label={"Patients"} name={"targetPatients"} readOnly={isReadOnly} options={targetGroups} labelSize={4} inputSize={8} />
                                                </>
                                            }
                                            <RenderSelectField label={"All Site Users"} name={"targetAllUsers"} readOnly={isReadOnly} options={targetGroups} labelSize={4} inputSize={8} />
                                            <RenderSelectField label={"Other"} name={"targetOtherUsers"} readOnly={isReadOnly} options={targetGroups} labelSize={4} inputSize={8} />
                                            <RenderTextField label={"Other Specified"} name={"otherUserType"} readOnly={isReadOnly} labelSize={12} inputSize={12} multiLine={true} rows={4} />
                                        </Stack>
                                    </Grid>
                                </DataContainer>
                            </Grid>
                        </Grid>
                    )}

                    <Grid container size={12}>
                        <Grid size={12}>
                            <DataContainer title="Travel Plan Targets">
                                <Grid size={12}>
                                    <RenderTextField label="What is the main objective/target of the Travel Plan" name="mainObjective" multiLine={true} rows={4} readOnly={isReadOnly} labelSize={12} inputSize={12} alwaysShow={true} />
                                </Grid>
                                <Grid size={12}>
                                    <RenderTextField label="What are the specific individual targets of the Travel Plan?" name="specificTargets" multiLine={true} rows={4} readOnly={isReadOnly} labelSize={12} inputSize={12} alwaysShow={true} />
                                </Grid>
                            </DataContainer>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={4} container>
                    {hasValues(["modalSplitBefore", "modalDataMonth", "modalDataYear", "tripsVehicle", "tripsCyclists", "tripsPublicTransport", "tripsPedestrians", "tripsOther", "modalDataSource"]) && (
                        <Grid container size={12}>
                            <Grid size={12}>
                                <DataContainer title="Pre-Travel Plan Mode Split">
                                    <Grid size={12}>
                                        <Stack spacing={1}>
                                            <RenderSelectField label="Was modal split data obtained before the introduction of the Travel Plan?" name="modalSplitBefore" options={yesNoDropdown} readOnly={isReadOnly} />
                                            <Grid size={12}>
                                                <Typography variant={"body2"}>If YES, when?</Typography>
                                            </Grid>
                                            <Stack direction="row" spacing={1}>
                                                <Grid size={6}>
                                                    <ValidatedSelectElement name={'modalDataMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                                </Grid>
                                                <Grid size={6}>
                                                    <ValidatedTextField name={'modalDataYear'} />
                                                </Grid>
                                            </Stack>
                                            <RenderTextField label="Vehicle Occupants" name="tripsVehicle" readOnly={isReadOnly} labelSize={7} inputSize={5} />
                                            <RenderTextField label="Cyclists" name="tripsCyclists" readOnly={isReadOnly} labelSize={7} inputSize={5} />
                                            <RenderTextField label="Public Transport Users" name="tripsPublicTransport" readOnly={isReadOnly} labelSize={7} inputSize={5} />
                                            <RenderTextField label="Pedestrians" name="tripsPedestrians" readOnly={isReadOnly} labelSize={7} inputSize={5} />
                                            <RenderTextField label="Other" name="tripsOther" readOnly={isReadOnly} labelSize={7} inputSize={5} />
                                            <RenderSelectField label="What was the source of this data?" name="modalDataSource" readOnly={isReadOnly} options={censusDataDropdown} labelSize={7} inputSize={5} />
                                        </Stack>
                                    </Grid>
                                </DataContainer>
                            </Grid>
                            <Grid container size={12}>
                                {prePlanChart.length !== 0 && <CrabPie data={prePlanChart} />}
                            </Grid>
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["splitTargets", "targetMonth", "targetYear", "targetTripsVehicle", "targetTripsCyclists", "targetTripsPublicTransport", "targetTripsPedestrians", "targetTripsOther", "targetPlanYear"]) && (
                        <Grid container size={12}>
                            <Grid size={12}>
                                <DataContainer title={"Travel Plan Modal Split Targets"}>
                                    <Grid size={12}>
                                        <Stack spacing={1}>
                                            <RenderSelectField label="Did the Travel Plan identify mode split targets?" name="splitTargets" options={yesNoDropdown} readOnly={isReadOnly} />
                                            <Grid size={12}>
                                                <Typography variant={"body2"}>If YES, when?</Typography>
                                            </Grid>
                                            <Stack direction="row" spacing={1}>
                                                <Grid size={6}>
                                                    <ValidatedSelectElement name={'targetMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                                </Grid>
                                                <Grid size={6}>
                                                    <ValidatedTextField name={'targetYear'} />
                                                </Grid>
                                            </Stack>
                                            <RenderTextField label="Vehicle Occupants" name="targetTripsVehicle" readOnly={isReadOnly} />
                                            <RenderTextField label="Cyclists" name="targetTripsCyclists" readOnly={isReadOnly} />
                                            <RenderTextField label="Public Transport Users" name="targetTripsPublicTransport" readOnly={isReadOnly} />
                                            <RenderTextField label="Pedestrians" name="targetTripsPedestrians" readOnly={isReadOnly} />
                                            <RenderTextField label="Other" name="targetTripsOther" readOnly={isReadOnly} />
                                            <RenderTextField label="Which year of the life of the Travel Plan do these targets represent?" name="targetPlanYear" readOnly={isReadOnly} />
                                        </Stack>
                                    </Grid>
                                </DataContainer>
                            </Grid>
                            <Grid container size={12}>
                                {modalChart.length !== 0 && <CrabPie data={modalChart} />}
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            <DftConnectivityToolScores
                score={site.dftConnectivityToolScore}
                eligible={site.isDftConnectivityToolEligible}
                enabled={site.isDftConnectivityToolEnabled}
                readOnly={true}
                travelPlanLayout
            />
        </>
    );
}
